export const TASK_LIST = 'TASK_LIST';
export const TASK_LIST_SUCCESS = 'TASK_LIST_SUCCESS';
export const TASK_LIST_ERROR = 'TASK_LIST_ERROR';
export const TASK_LIST_DETAILS = 'TASK_LIST_DETAILS';
export const TASK_LIST_DETAILS_ERROR = 'TASK_LIST_DETAILS_ERROR';
export const TASK_LIST_DETAILS_SUCCESS = 'TASK_LIST_DETAILS_SUCCESS';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';
export const REPORT_ALARM_DETAILS = 'REPORT_ALARM_DETAILS';